import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, ShieldCheck } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && user?.is_admin) navigate("/admin");
  }, [user, loading, navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5 py-16">
      <div className="bg-white rounded-2xl border shadow-[0_30px_60px_-30px_rgba(22,38,63,0.35)] max-w-md w-full p-9 text-center" style={{ borderColor: "var(--cream-dark)" }}>
        <div className="w-16 h-16 rounded-full bg-navy flex items-center justify-center mx-auto">
          <ShieldCheck size={28} className="text-teal" />
        </div>
        <h1 className="font-serif-display text-3xl font-bold text-navy mt-6">Admin Sign In</h1>
        <p className="font-ui text-navy/65 mt-3 leading-relaxed">
          This area is private to the BOSSY team. Sign in with the authorized Google account to view inquiries,
          bookings, and leads.
        </p>
        <button
          onClick={handleLogin}
          className="mt-8 w-full inline-flex items-center justify-center gap-3 bg-navy text-cream px-6 py-3.5 rounded-full font-ui font-semibold hover:bg-orange transition-colors"
        >
          <LogIn size={18} /> Continue with Google
        </button>
        <p className="font-ui text-xs text-navy/40 mt-5">
          Only allowlisted accounts (bossyroc@gmail.com) can access the dashboard.
        </p>
      </div>
    </div>
  );
}
